<style scoped>
	/* model box */
  .content-model-box {
    width: 650px;
    height: 500px;
    background: #FFFFFF;
    box-shadow: 1px 1px 10px 0 rgba(255, 255, 255, 1);
    border-radius: 5px;
    margin-top: 120px;
  }

  .content-model-box > .top-title {
    height: 40px;
    line-height: 40px;
    text-align: left;
    background: rgba(243, 243, 243, 1);
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    padding-left: 20px;
    font-size: 16px;
    position: relative;
  }

  .content-model-box > .top-title > .close-btn {
    position: absolute;
    right: 10px;
    top: 0;
    cursor: pointer;
  }

  .content-model-box > .top-title > .close-btn:hover {
    color: #DF402D;
  }

  .content-model-box > .from-box {
    display: flex;
    flex-direction: column;
    max-height: calc(100% - 40px);
    overflow: auto;
    padding: 0 20px;
  }

  .content-model-box > .from-box > .from-col {
    display: flex;
    justify-content: flex-start;
    margin: 8px 0;
  }

  .content-model-box > .from-box > .from-col > .from-title {
    width: 100px !important;
    text-align: right;
    padding-right: 20px !important;
  }

  /* model - end */

  .shop-car {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  .content-box {
    flex: 1;
  }

  /*h3-title*/
  .h3-title {
    text-align: left;
    font-size: 16px;
  }

  .content-inner {
    margin-top: 10px;
    border: 1px solid #cccccc;
  }

  .padding-20 {
    padding: 15px 20px;
  }

  .padding-lr-20 {
    padding: 0 20px;
  }

  /*address-info*/
  .address-info > .top {
    display: flex;
    justify-content: space-between;
  }

  .address-info > .top > h3 {
    text-align: left;
    font-weight: bold;
    font-size: 15px;
  }

  .address-info > .top > a {
    font-weight: 400;
    color: rgba(8, 118, 205, 1);
  }

  /* 收货地址列表 */
  .address-info > .address-bottom {
    max-height: 160px;
    border-bottom: 1px solid rgba(226, 226, 226, 1);
    overflow: auto;
  }

  .address-info > .address-bottom > .address-item {
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
  }

  .address-info > .address-bottom > .address-item > .a-left {
    display: flex;
    align-items: center;
  }

  .address-info > .address-bottom > .address-item > .a-right {
    width: 53px;
    height: 26px;
    border: 1px solid rgba(187, 187, 187, 1);
    line-height: 26px;
    color: #4A4A4A;
  }

  .address-info > .address-bottom > .address-item > .a-left > div.checked-bg {
    background: url("../../assets/images/right_down.png") no-repeat;
    background-position: calc(100% + 1px) calc(100% + 1px);
    border: 2px solid rgba(13, 121, 207, 1) !important;
  }

  .address-info > .address-bottom > .address-item > .a-left > div:nth-child(1) {
    width: 144px;
    height: 30px;
    line-height: 30px;
    border: 2px solid #E2E2E2;
    margin-right: 20px;
  }

  .address-info > .address-bottom > .address-item > .a-left > div:nth-child(2) > span:nth-child(2) {
    padding: 3px 7px;
    display: inline-block;
    color: #ffffff;
    background: linear-gradient(0deg, rgba(54, 153, 229, 1) 0%, rgba(8, 118, 206, 1) 100%);
  }

  /*    table   */
  /* order info */
  .order-info > .order-title {
    text-align: left;
    font-weight: bold;
    font-size: 15px;
  }

  /*table - inner - content */
  .weight-font {
    font-weight: bold;
  }

  .red-color {
    color: red;
  }

  .row .goods-detail {
    display: inline-flex;
    align-items: center;
    width: 80%;
    padding: 10px;
  }

  .row .goods-detail > .head-img {
    width: 80px;
    /*height: 80px ;*/
  }

  .row .goods-detail > .detail {
    text-align: left;
    margin-left: 15px;
  }

  .row .goods-detail > .detail > .goods-info:nth-child(1) {
    /*line-height: 40px;*/
    padding: 5px 0 5px 0 !important;


  }

  .row .goods-detail > .detail > .goods-info:nth-child(n + 2) {
    line-height: 20px;
    color: #666666;
  }

  /* table-bottom-info */
  /* table-bottom-info */
  .order-table {

  }

  .order-table > .table-bottom-info {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 20px 0;
    font-size: 14px;

  }

  .order-table > .table-bottom-info > div {
    background: #F2F7FF;
    width: 50%;
    height: 50px;
    line-height: 50px;
    box-sizing: border-box;
    display: flex;
    padding: 0 20px;
	align-items: center;
  }

  .order-table > .table-bottom-info > div:nth-child(1) {
    border-right: 2px solid #ffffff;
    border-bottom: 2px solid #ffffff;
  }

  .order-table > .table-bottom-info > div:nth-child(2) {
    border-left: 2px solid #ffffff;
    border-bottom: 2px solid #ffffff;
  }

  .order-table > .table-bottom-info > div:nth-child(3) {
    border-right: 2px solid #ffffff;
    border-top: 2px solid #ffffff;
  }

  .order-table > .table-bottom-info > div:nth-child(4) {
    border-left: 2px solid #ffffff;
    border-top: 2px solid #ffffff;
  }

  .order-table > .table-bottom-info > div:nth-child(2n-1) {
    justify-content: space-between;
  }

  .order-table > .table-bottom-info > div:nth-child(2n) {
    justify-content: flex-end;
  }

  .order-table > .table-bottom-info > div:nth-child(2n) > span:nth-child(1) {
    margin-right: 50px;
  }

  /* table-bottom-order-confirm */
  /* table-bottom-order-confirm */
  .order-table > .table-bottom-order-confirm {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin: 5px 0 20px 0;
    text-align: right;
  }

  .order-table > .table-bottom-order-confirm > div:nth-child(1) {
    border: 1px solid rgba(7, 117, 204, 1);
    box-shadow: 0 -1px 7px 0 rgba(9, 119, 207, 0.42);
    padding: 10px;
  }

  .order-table > .table-bottom-order-confirm > div:nth-child(1) > P {
    margin: 5px 0 !important;
    font-size: 14px !important;
  }

  .order-table > .table-bottom-order-confirm > div:nth-child(2) {
    width: 181px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    font-size: 18px;
    font-weight: bold;
    background: linear-gradient(0deg, rgba(5, 115, 203, 1) 0%, rgba(63, 159, 234, 1) 100%);
    cursor: pointer;
  }
	.show{
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
		width: 300px;
	}
	.flex1{
		flex:1;
	}

  .price-index-items{
    display: flex;
    width: 100%;
  }
  .price-index-items>p:nth-child(1){
    width: 30%;
    text-align: left;
  }
</style>

<template>
	<div class="shop-car">
		<div class="top-box">
			<HeaderTop></HeaderTop>
			<HeaderTitle :pageName="$t('placeorder.Shopping')" topType="line"></HeaderTitle>
			<Back />
		</div>
		<div class="content-box word">
			<h3 class="h3-title">{{$t('placeorder.userinformation')}}</h3>
			<div class="content-inner">
				<!--address info-->
				<div class="address-info">
					<div class="top padding-20">
						<h3>{{$t('placeorder.shinformation')}}</h3>
						<a href="javascript:void(0);" @click="addAddress">{{$t('placeorder.shaddress')}}</a>
					</div>
					<div class="address-bottom padding-lr-20">
						<div class="address-item" v-for="(item , index) in addressList">
							<div class="a-left">
								<div @click="checkedAddress(index)" :class="checkedAddressIndex === index ? 'checked-bg' : ''">
									{{item.contacts}}
								</div>
								<div>
									<span>{{item.country.split(',').join(' ') + ' ' + item.address + ' ' + item.contactPhone}}</span>
									<span v-if="item.defaultState === 1">{{$t('placeorder.mraddress')}}</span>
								</div>
							</div>
							<div class="a-right" @click="editAddressInCar(index)">{{$t('placeorder.edit')}}</div>
						</div>
					</div>
				</div>
				<!--order-->
				<div class="order-info">
					<h3 class="order-title padding-20">{{$t('placeorder.ddinformation')}}</h3>
					<!--table-->
					<div class="order-table padding-20">
						<div class="c-t-head">
							<div v-for="item in thead" class="col" :class="item.width + ' ' + item.align">{{item.title}}</div>
						</div>
						<div class="c-t-body">
							<div class="row" v-if="dataList.length <= 0"><span class="none-data">{{$t('placeorder.Nodata')}}...</span></div>
							<div v-if="dataList.length > 0" class="row" v-for="(outItem,outIndex) in dataList">
								<div v-for="(item,index) in thead" class="col" :class="item.width + ' ' + item.align">
									<!--col 1-->
									<template v-if="index === 0">
										<div class="goods-detail">
											<img class="head-img" :src="outItem.productImg?$img+outItem.productImg.split(',')[0]:''" />
											<div class="detail">
												<p class="goods-info">{{outItem.productName}}</p>
												<p class="goods-info">{{$t('placeorder.number')}}：{{outItem.productNum}}</p>
												<p class="goods-info show">{{$t('placeorder.describe')}}：{{outItem.productDescribe}}</p>
												<div class="price-index-items" v-for="item1 in outItem.priceIndex">
													<p>{{$t('product.buy') + item1.num}}</p>
													<p>{{$t('product.unitPrice') + `：${$type == 1?'￥':'$'}` + item1.price / 100}}</p>
												</div>
											</div>
										</div>
									</template>
									<!--col 2-->
									<template v-if="index === 1">
										<div style="text-align: left;">
											<span>{{`${$type == 1?'￥':'$'}` + (outItem.unitPrice / 100).toFixed(2)}}</span><br />
											<span style="color: #993a1d;">原价：{{`${$type == 1?'￥':'$'}` + (outItem.price0 / 100).toFixed(2)}}</span>
										</div>
									</template>
									<!--col 3-->
									<template v-if="index === 2">x {{outItem.num ? outItem.num : $route.query.number}}</template>
									<!--col 4-->
									<template v-if="index === 3">
										<span class="red-color">{{`${$type == 1?'￥':'$'}` + (outItem.unitPrice * (outItem.num?outItem.num:$route.query.number) / 100 ).toFixed(2)}}</span>
									</template>
								</div>
							</div>
						</div>
						<!-- bottom - order - info -->
						<div class="table-bottom-info">
							<div>
								<el-checkbox v-model="integral" label="2" @change="usePoints">{{$t('placeorder.use')}}<span style="color: red;">{{maxIntegral}}</span>{{$t('placeorder.Creditdeduction')}}{{`${$type == 1?'￥':'$'}` + Maxmoney}}{{$t('placeorder.element')}}</el-checkbox>
								<span class="red-color weight-font">-{{Maxmoney}}</span>
							</div>
							<div>
								<span>{{$t('placeorder.Modeofdelivery')}}</span>
								<span class="red-color weight-font">0.00</span>
							</div>
							<div>
								<el-checkbox v-model="radio" label="1" @change="vipDiscount">{{$t('placeorder.Memberdiscount')}}{{Discount}}{{$t('placeorder.fracture')}}</el-checkbox>
								<span class="red-color weight-font">-{{(num?reduceMoney*$route.query.number:reduceMoney).toFixed(2)}}</span>
							</div>
							<div>
								<span>{{$t('placeorder.Totalgoods')}}</span>
								<span class="red-color weight-font">{{`${$type == 1?'￥':'$'}` + (num?$route.query.number*sun:sun).toFixed(2)}}</span>
							</div>
						</div>
						<div class="table-bottom-order-confirm">
							<div class="detail-b">
								<p>{{$t('placeorder.Actualpayment')}}：<span class="red-color weight-font" style="font-size: 18px">{{`${$type == 1?'￥':'$'}` + (num?numbers*money:money).toFixed(2)}}</span></p>
								<p>{{$t('placeorder.To')}}：{{checkAddress.addressDetail}}</p>
								<p>{{$t('placeorder.consignee')}}：{{checkAddress.custerInfo}}</p>
							</div>
							<div @click="placeanOrder">{{$t('placeorder.Ordernow')}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!--  添加地址模态框-->
		<ModelPop v-if="showModel">
			<div class="content-model-box">
				<div class="top-title">
					<span>{{modelType === 1 ? $t('placeorder.newlyadded') : $t('placeorder.edit')}}{{$t('shopDet.address')}}</span>
					<span class="close-btn" @click="() => showModel = false ">{{ $t('placeorder.close')}}</span>
				</div>
				<div class="from-box">
					<div class="from-col">
						<p class="from-title"><span style="color:red;">*</span>{{dataTitleGroup. mechanismName}}：</p>
						<div class="flex1">
							<el-input :placeholder="$t('placeorder.Pleaseenter')" maxlength="50" type="text" v-model="dataGroup.mechanismName"></el-input>
						</div>
					</div>
					<div class="from-col">
						<p class="from-title"><span style="color:red;">*</span>{{dataTitleGroup.contacts}}：</p>
						<div class="flex1">
							<el-input :placeholder="$t('placeorder.Pleaseenter')" maxlength="50" type="text" v-model="dataGroup.contacts"></el-input>
						</div>
					</div>

					<div class="from-col">
						<p class="from-title"><span style="color:red;">*</span>{{dataTitleGroup.country}}</p>
						<el-cascader v-model="dataGroup.country" :options="options" :props="{ expandTrigger: 'hover' }"></el-cascader>
					</div>
					<div class="from-col">
						<p class="from-title"><span style="color:red;">*</span>{{dataTitleGroup.address}}：</p>
						<div class="flex1">
							<el-input :placeholder="$t('placeorder.Pleaseenter')" maxlength="50" type="text" v-model="dataGroup.address"></el-input>
						</div>
					</div>
					<div class="from-col">
						<p class="from-title"><span style="color:red;">*</span>{{dataTitleGroup.zipCode}}：</p>
						<div class="flex1">
							<el-input :placeholder="$t('placeorder.Pleaseenter')" maxlength="50" type="text" v-model="dataGroup.zipCode"></el-input>
						</div>
					</div>
					<div class="from-col">
						<p class="from-title"><span style="color:red;">*</span>{{dataTitleGroup.contactPhone}}：</p>
						<div class="flex1">
							<el-input :placeholder="$t('placeorder.Pleaseenter')" maxlength="50" type="text" v-model="dataGroup.contactPhone"></el-input>
						</div>
					</div>
					<div class="from-col">
						<p class="from-title"></p>
						<el-button type="primary" @click="submitDataInShopCar">{{$t('placeorder.Submit')}}</el-button>
					</div>
				</div>
			</div>
		</ModelPop>
		<PageFooter></PageFooter>
	</div>
</template>

<script>
	import '../../assets/css/l-table.css';
	import HeaderTop from "../assembly/HeaderTop";
	import HeaderTitle from "../assembly/HeaderTitle";
	import PageFooter from "../assembly/PageFooter";
	import LoginPop from "../assembly/LoginPop";
	import Back from '../assembly/Back';
	import ModelPop from "../assembly/ModelPop";

	export default {
		name: "SubmitOrder",
		components: {
			HeaderTop,
			HeaderTitle,
			PageFooter,
			LoginPop,
			Back,
			ModelPop
		},
		data() {
			return {
				orderNo: '',
				loadingPay: false,
				integral: false,
				radio: false,
				showModel: false,
				modelType: 1,
				editIndex: -1,
				dataList: [],
				addressList: [],
				checkedAddressIndex: 0,

				checkAddress: {
					addressDetail: '',
					custerInfo: '',
					tel: '',
					name: ''
				},
				thead: [],
				dataGroup: {
					mechanismName: '',
					contacts: '',
					country: '',
					address: '',
					zipCode: '',
					contactPhone: ''
				},
				numbers: 1,
				dataTitleGroup: {},
				options: [],
				token: '',
				carIds: '',
				sun: null,
				Maxmoney: null, // 最大积分抵扣
				money: null,
				Discount: null, // 折扣
				discountType: "",
				carArr: [],
				numArr: [],
				productArr: [],
				productNumArr: [],
				num: "",
				maxIntegral: "",
				reduceMoney: ''
			};
		},
		created() {
			this.thead = this.$t('placeorder.thead');
			this.numbers = this.$route.query.number;
			this.num = this.$route.query.num ? this.$route.query.num : '';
			let carIds = this.$route.query.carIds ? this.$route.query.carIds : '';
			this.dataTitleGroup = this.$t('Receipt.dataTitleGroup')
			this.carIds = carIds;
			this.token = sessionStorage.getItem('token');
			this.mineAddress();
			this.getAddressMsg();
			if (this.num) {
				this.getProduct()
			} else {
				this.initShopCarGoods(carIds);
			}
		},
		methods: {
			getProduct() {
				this.$get('/open/product/getProduct', {
					productId: this.carIds,
					token: this.token,
				}).then(res => {
					// this.dataList.push(res.data);
					let data = res.data;
					let price = res.data.unitPrice;
					let {
						priceIndex
					} = res.data;
					data.priceIndex = [];
					if (priceIndex && priceIndex !== 'null') {
						let temp = JSON.parse(priceIndex).sort((a, b) => a.num - b.num);
						temp.forEach(item => {
							if (item.num <= this.numbers) {
								price = item.price;
							}
						});
						data.priceIndex = temp;
					}
					data.price0 = data.unitPrice;
					data.unitPrice = price;
					this.dataList.push(data);
					this.money = price / 100;
					this.sun = price / 100;
					this.getMaxmoney()
				})
			},
			usePoints(e) {
				if (this.integral) {
					this.money = this.$route.query.number ? this.sun - (this.Maxmoney / this.$route.query.number) : this.sun - this.Maxmoney
					this.discountType = 2
					this.radio = false
				} else {
					this.money = this.sun
					this.discountType = ''
				}
			},
			vipDiscount() {
				if (this.radio) {
					this.money = this.sun * (this.Discount / 10);
					this.discountType = 1
					this.integral = false
				} else {
					this.money = this.sun;
					this.discountType = ''
				}
			},
			// 购物车下单
			carshop() {
				let url = '/api/shop/car/batch/add'
				let data = {
					discountType: this.discountType ? this.discountType : 3,
					integralMoney: this.discountType == 2 ? (this.Maxmoney * 100) : 0,
					integralNum: this.integral ? this.maxIntegral : (this.Discount*10),
					productInfos: JSON.stringify(this.carArr),
					receivingAddress: this.checkAddress.addressDetail,
					receivingPhone: this.checkAddress.tel,
					receivingUser: this.checkAddress.name,
					token: sessionStorage.getItem('token')
				}
				this.$post(url, data).then(res => {
					if (res.code == 0) {
						this.orderNo = res.data
						let routerData = {
							payAmount: res.params.usMoney,
							zhMoney: res.params.zhMoney,
							orderNo: res.data,
							pageName: this.$t('vip.finished'),
							orderType: 0 //成品订单
						};
						//显示弹窗
						// this.showModalFn();
						sessionStorage.setItem("paydatainfo", JSON.stringify(routerData));
						let routerLinkData = this.$router.resolve({
							path: "/payPage"
						});
						window.open(routerLinkData.href, "_blank");
					}
				})
			},
			// 产品下单
			standardShop() {
				let url = '/api/standard/order/add'
				let data = {
					discountType: this.discountType ? this.discountType : 3,
					// integralMoney: this.discountType == 2 ? this.Maxmoney : 0,
					integralNum: this.integral ? this.maxIntegral : this.Discount * 10,
					moneyNum: Math.ceil((this.money * this.$route.query.number) * 100),
					num: this.$route.query.number,
					productId: this.dataList[0].productId,
					productName: this.dataList[0].productName,
					productNum: this.dataList[0].productNum,
					receivingAddress: this.checkAddress.addressDetail,
					receivingPhone: this.checkAddress.tel,
					receivingUser: this.checkAddress.name,
					token: sessionStorage.getItem('token'),
					unitPrice: this.dataList[0].unitPrice
				}
				this.$post(url, data).then(res => {
					if (res.code == 0) {
						this.orderNo = res.data
						let routerData = {
							payAmount: res.params.usMoney,
							zhMoney: res.params.zhMoney,
							orderNo: res.data,
							pageName: this.$t('vip.finished'),
							orderType: 0 //成品订单
						};
						//显示弹窗
						sessionStorage.setItem("paydatainfo", JSON.stringify(routerData));
						let routerLinkData = this.$router.resolve({
							path: "/payPage"
						});
						window.open(routerLinkData.href, "_blank");
					}
				})
			},
			// 立即下单
			placeanOrder() {

				if (this.checkAddress.addressDetail == '' || this.checkAddress.custerInfo == '') {
					this.$message.error('请添加收货地址');
					return false
				}
				if (this.num) {
					this.standardShop()
				} else {
					this.carshop()
				}
				setTimeout(() => {
					this.$confirm(this.$t('message.whether'), {
							distinguishCancelAndClose: true,
							confirmButtonText: this.$t('message.zfsuccess'),
							cancelButtonText: this.$t('message.zfdestruction')
						})
						.then(() => {
							this.$router.push('/all/order');
						})
						.catch(action => {
							this.$router.push('/all/order');
						});
				}, 2000)
			},
			getMaxmoney() {
				this.$get('/api/account/consumer/discount', {
					token: this.token
				}).then(res => {
					res.data.discount.discount = res.data.discount.discount / 10
					this.Maxmoney = ((res.data.integralToMoney.maxMoney) / 100) > this.money ? this.money : (res.data.integralToMoney
						.maxMoney) / 100
					this.Discount = res.data.discount.discount
					this.maxIntegral = res.data.integralToMoney.maxIntegral
					this.reduceMoney = this.money - this.money * (this.Discount / 10)
				})
			},
			//获取购物车商品信息并确认订单
			initShopCarGoods(ids) {
				this.$get('api/shop/car/select/list/ids', {
					ids,
					token: this.token
				}).then(res => {
					if (res.code === 0) {
						this.dataList = res.data;
						this.dataList.map((item, index) => {
							let price = item.unitPrice;
							let {
								priceIndex
							} = item;
							item.priceIndex = [];
							if (priceIndex && priceIndex !== 'null') {
								let temp = JSON.parse(priceIndex).sort((a, b) => a.num - b.num);
								temp.forEach(item1 => {
									if (item1.num <= item.num) {
										price = item1.price;
									}
								});
								item.priceIndex = temp;
							}
							item.price0 = item.unitPrice;
							item.unitPrice = price;
							this.sun += (item.num * price) / 100;
							this.carArr.push({
								'carId': item.carId,
								'num': item.num,
								'productId': item.productId,
								'productNum': item.productNum
							})
						});
						this.money = this.sun
						this.getMaxmoney()
					}
				})
			},

			/////////////////////////收货地址相关///////////////////////////
			//选中地址
			checkedAddress(index) {
				if (index === this.checkedAddressIndex) return;
				this.checkedAddressIndex = index;
				this.saddress(index);
			},
			//同步地址
			saddress(index) {
				let item = this.addressList[index];
				this.checkAddress = {
					addressDetail: item.country.split(',').join('  ') + ' ' + item.address,
					custerInfo: item.contacts + ' ' + item.contactPhone,
					tel: item.contactPhone,
					name: item.contacts
				};
			},
			//添加地址
			addAddress() {
				this.showModel = true;
				this.modelType = 1;
				Object.keys(this.dataGroup).forEach(item => this.dataGroup[item] = '');
			},
			/**
			 * 编辑地址
			 */
			editAddressInCar(index) {
				this.editIndex = index;
				let editData = this.addressList[index];
				this.modelType = 2;
				Object.keys(this.dataGroup).forEach(item => {
					if (item === 'country') {
						this.dataGroup[item] = editData[item].split(',');
					} else {
						this.dataGroup[item] = editData[item] + '';
					}
				});
				this.showModel = true;
			},
			//获取地址三级联动
			getAddressMsg() {
				this.$get(`open/linkage/tree?token${sessionStorage.getItem('token')}`).then(res => {
					if (res.code === 0) {
						this.options = this.constData(res.data);
					}
				});
			},
			//购物车新增地址提交方法
			submitDataInShopCar() {
				this.$confirm(this.$t('Tips.dataTips'), this.$t('Tips.Tips')).then(res => {
					if (!this.checkData()) return;
					let datas = { ...this.dataGroup,
						token: this.token
					};
					datas.country = this.dataGroup.country.join(',');
					if (this.modelType === 2) {
						datas.addressId = this.addressList[this.editIndex].addressId;
					}
					this.$post(this.modelType === 1 ? 'api/address/add' : 'api/address/edit', datas).then(res => {
						if (res.code === 0) {
							this.showModel = false;
							Object.keys(this.dataGroup).forEach(item => this.dataGroup[item] = '');
							this.$message({
								type: 'success',
								message: this.$t('Tips.Submitsue')
							});
							this.mineAddress();
						}
					})
				}).catch(() => {
					this.$message({
						type: 'warning',
						message: '取消操作'
					})
				})
			},
			//校验参数
			checkData() {
				let dataGroup = this.dataGroup;
				let keys = Object.keys(dataGroup);
				for (const key of keys) {
					if (!(dataGroup[key] + '').trim()) {
						this.$message({
							type: 'warning',
							message: '请填写' + this.dataTitleGroup[key]
						});
						return;
					}
				}
				return true;
			},
			//获取我的收货地址
			mineAddress() {
				this.$get('api/address/list', {
					token: this.token,
					pageNum: 1,
					pageSize: 30
				}).then(res => {
					if (res.code === 0) {
						this.addressList = res.data;
						this.checkedAddressIndex = 0;
						this.saddress(0);
					}
				});
			},
			//构造多级联动树
			constData(data) {
				let result = [];
				for (let i = 0, len = data.length; i < len; i++) {
					let c = this.constData(data[i].children);
					result.push({
						value: data[i].name,
						label: data[i].name,
						[c.length <= 0 ? '' : 'children']: c
					});
				}
				return result;
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/shopCar/SubmitOrder.vue